import React from 'react';
import { FileText, Trash2 } from 'lucide-react';

const Header = ({ onClear, hasText }) => (
  <div style={{
    background: 'white',
    border: '5px solid #d53369',
    boxShadow: '12px 12px 0px rgba(0,0,0,0.4)',
    marginBottom: '24px'
  }}>
    <div style={{
      background: '#d53369',
      padding: '24px',
      borderBottom: '5px solid #b82c5a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <FileText size={24} color="white" />
        <h1 style={{
          fontSize: '18px',
          color: 'white',
          margin: 0,
          letterSpacing: '2px'
        }}>
          WORD COUNTER
        </h1>
      </div>
      {hasText && (
        <button
          onClick={onClear}
          style={{
            background: '#e53e3e',
            color: 'white',
            border: '3px solid #c53030',
            padding: '12px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '10px',
            boxShadow: '4px 4px 0px rgba(0,0,0,0.3)',
            transition: 'all 0.2s ease',
            fontFamily: '"Press Start 2P", monospace'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translate(-2px, -2px)';
            e.currentTarget.style.boxShadow = '6px 6px 0px rgba(0,0,0,0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translate(0, 0)';
            e.currentTarget.style.boxShadow = '4px 4px 0px rgba(0,0,0,0.3)';
          }}
        >
          <Trash2 size={14} />
          LIMPIAR
        </button>
      )}
    </div>
  </div>
);

export default Header;